import { render, staticRenderFns } from "./Litigationcourtlevel.vue?vue&type=template&id=5b8ef9c7&scoped=true&"
import script from "./Litigationcourtlevel.vue?vue&type=script&lang=js&"
export * from "./Litigationcourtlevel.vue?vue&type=script&lang=js&"
import style0 from "./Litigationcourtlevel.vue?vue&type=style&index=0&id=5b8ef9c7&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b8ef9c7",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VForm } from 'vuetify/lib/components/VForm';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCard,VDialog,VForm,VTextField})
